// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2454":"b66c4806eb00c141","7398":"771c4b6d653d11a0"}[chunkId] + ".css";
};